export default "__VITE_ASSET__BNBp85tk__"